import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

const ShippingTable = styled.div`
    ${tw`w-full mt-4`}
`;

const TableHeaderRow = styled.div`
    ${tw`flex justify-between items-center py-2 border-b border-gray-200`}
`;

const TableRow = styled.div`
    ${tw`flex justify-between items-center py-2 border-b border-gray-200`}
    
`;

const TableCell = styled.div`
    ${tw`text-sm text-gray-600`}
    width: ${(props) => props.width || 'auto'};
    text-align: left;
    border-bottom: 1px solid #e5e7eb; /* Добавлено для нижней линии */
    padding-bottom: 15px;
    
    a {
        text-decoration: none;
        color: #0ABD19;
    }
`;



const InfoSection = styled.div`
    ${tw`mb-6 p-4 bg-gray-500 rounded-lg`}
`;

const InfoRow = styled.div`
    ${tw`flex justify-between py-2 border-b border-gray-200`}
`;

const InfoLabel = styled.div`
    ${tw`text-sm font-semibold text-gray-700`}
`;

const InfoValue = styled.div`
    ${tw`text-sm text-gray-600`}
`;

const FormShipping = ({ parcelData }) => {
    // Функция для получения названия тарифа СДЕК по коду
    const getCdekTariffName = (code) => {
        const tariffs = {
            136: 'Посылка склад-склад',
            137: 'Посылка склад-дверь',
            138: 'Посылка дверь-склад',
            139: 'Посылка дверь-дверь',
            // Добавьте другие тарифы по необходимости
        };
        return tariffs[code] || `Тариф ${code}`;
    };

    const shippingData = parcelData ? [
        {
            number: parcelData.trackingNumber || 'Не указан',
            type: parcelData.cdekTariffCode ? getCdekTariffName(parcelData.cdekTariffCode) : 'Не указан',
            cost: parcelData.cdekDeliveryCost ? `${parcelData.cdekDeliveryCost} ₸` : '0 ₸',
            address: parcelData.cdekDeliveryPointAddress || 'Адрес не указан',
            palletId: parcelData.palletId || 'Не назначен',
            shippingId: parcelData.shippingId || 'Не назначен',
            shippingDate: parcelData.shippingDate || 'Не отправлено',
            status: parcelData.status || 'Не указан',
        },
    ] : [];

    return (
        <>
            {parcelData && parcelData.cdekTariffCode && (
                <InfoSection>
                    <h4 style={{ marginBottom: '1rem', fontSize: '16px', fontWeight: '600' }}>Информация о доставке СДЕК</h4>
                    <InfoRow>
                        <InfoLabel>Тариф СДЕК:</InfoLabel>
                        <InfoValue>{getCdekTariffName(parcelData.cdekTariffCode)} (код: {parcelData.cdekTariffCode})</InfoValue>
                    </InfoRow>
                    <InfoRow>
                        <InfoLabel>Стоимость доставки СДЕК:</InfoLabel>
                        <InfoValue>{parcelData.cdekDeliveryCost ? `${parcelData.cdekDeliveryCost} ₸` : 'Не рассчитана'}</InfoValue>
                    </InfoRow>
                    <InfoRow>
                        <InfoLabel>Адрес пункта выдачи (ПВЗ):</InfoLabel>
                        <InfoValue>{parcelData.cdekDeliveryPointAddress || 'Не указан'}</InfoValue>
                    </InfoRow>
                    <InfoRow>
                        <InfoLabel>Код пункта выдачи:</InfoLabel>
                        <InfoValue>{parcelData.cdekDeliveryPointCode || 'Не указан'}</InfoValue>
                    </InfoRow>
                </InfoSection>
            )}
            <ShippingTable>
                <TableHeaderRow>
                    <TableCell width="10%">Исходящий трек</TableCell>
                    <TableCell width="10%">Способ доставки</TableCell>
                    <TableCell width="10%">Стоимость доставки</TableCell>
                    <TableCell width="20%">Адрес доставки</TableCell>
                    <TableCell width="10%">Номер паллета</TableCell>
                    <TableCell width="15%">Shipping ID</TableCell>
                    <TableCell width="10%">Дата отправки</TableCell>
                    <TableCell width="15%">Статус</TableCell>
                </TableHeaderRow>
                {shippingData.map((data, index) => (
                    <TableRow key={index}>
                        <TableCell width="10%">{data.number}</TableCell>
                        <TableCell width="10%">{data.type}</TableCell>
                        <TableCell width="10%">{data.cost}</TableCell>
                        <TableCell width="20%">{data.address}</TableCell>
                        <TableCell width="10%">{data.palletId}</TableCell>
                        <TableCell width="15%">{data.shippingId}</TableCell>
                        <TableCell width="10%">{data.shippingDate}</TableCell>
                        <TableCell width="15%">{data.status}</TableCell>
                    </TableRow>
                ))}
            </ShippingTable>
        </>
    );
};

export default FormShipping;